import axios, { AxiosRequestConfig } from "axios";
import { client } from "services/keycloak/client";
import { env } from "config";

const storeUrl = `${env.REACT_APP_JMIX_STORE_BACKEND_URL}/app/rest/v3`;

export type AccountInfo = {
  email: string,
  firstName: string,
  lastName: string,
  company: string,
  newsletter: boolean,
}

export type LinkedAccount = {
  connected: boolean,
  displayName: string,
  linkedUsername: string,
  providerAlias: string,
  providerName: string,
  social: boolean,
}

export type DeleteAccount = {
  success: boolean,
  repeatIn: number,
}

function updateKeycloakToken() {
  client.updateToken(60)
    .then((refreshed) => {
      if (refreshed) {
        console.log("Token was successfully refreshed");
      } else {
        console.log("Token is still valid");
      }
    }).catch(function () {
    client.login();
  });
}

export async function getAccountInfo(): Promise<AccountInfo> {
  updateKeycloakToken();

  const config: AxiosRequestConfig = {
    method: "get",
    url: `${env.REACT_APP_KEYCLOAK_URL}/realms/${env.REACT_APP_KEYCLOAK_REALM}/account`,
    headers: {
      "Authorization": `Bearer ${client.token}`,
      "Content-Type": "application/json",
    }
  };

  return axios.request(config)
    .then(({ data }) => {
      const accountInfo: AccountInfo = {
        email: data.email,
        firstName: data.firstName,
        lastName: data.lastName,
        company: data.attributes?.company?.[0],
        newsletter: data.attributes?.newsletter?.[0] === "on"
      };

      return accountInfo;
    });
}

export async function updateAccountInfo(accountInfo: AccountInfo): Promise<boolean> {
  updateKeycloakToken();

  const config: AxiosRequestConfig = {
    method: "post",
    url: `${env.REACT_APP_KEYCLOAK_URL}/realms/${env.REACT_APP_KEYCLOAK_REALM}/account`,
    headers: {
      "Authorization": `Bearer ${client.token}`,
      "Content-Type": "application/json",
    },
    data: {
      firstName: accountInfo.firstName,
      lastName: accountInfo.lastName,
      attributes: {
        company: [
          accountInfo.company
        ],
        newsletter: [
          accountInfo.newsletter ? "on" : ""
        ]
      }
    }
  };

  return axios.request(config)
    .then(() => {
      return true;
    });
}

export async function getLinkedAccount(): Promise<LinkedAccount[]> {
  updateKeycloakToken();

  const config: AxiosRequestConfig = {
    method: "get",
    url: `${env.REACT_APP_KEYCLOAK_URL}/realms/${env.REACT_APP_KEYCLOAK_REALM}/account/linked-accounts`,
    headers: {
      "Authorization": `Bearer ${client.token}`,
      "Content-Type": "application/json",
    }
  };

  return axios.request(config)
    .then(({ data }) => {
      const linkedAccount: LinkedAccount[] = data.map((item: any) => {
        return {
          connected: item.connected,
          displayName: item.displayName,
          linkedUsername: item.linkedUsername,
          providerAlias: item.providerAlias,
          providerName: item.providerName,
          social: item.social,
        };
      });

      return linkedAccount;
    });
}


export function updatePassword() {
  const keycloakUrl = env.REACT_APP_KEYCLOAK_URL;
  const realm = env.REACT_APP_KEYCLOAK_REALM;
  const clientId = env.REACT_APP_KEYCLOAK_CLIENT_ID;

  const updatePasswordUri = `${keycloakUrl}/realms/${realm}/protocol/openid-connect/auth`
      + `?client_id=${clientId}&redirect_uri=${window.location.origin}&response_type=code&scope=openid&kc_action=UPDATE_PASSWORD`;

  window.open(updatePasswordUri, "_blank");
}

export async function exportAccountInfo() {
  updateKeycloakToken();

  window.open(`${storeUrl}/profile/report?access_token=${client.token}`, "_blank");
}

export async function deleteAccount() {
  updateKeycloakToken();

  const config: AxiosRequestConfig = {
    method: "get",
    url: `${storeUrl}/profile/delete`,
    headers: {
      "Authorization": `Bearer ${client.token}`,
      "Content-Type": "application/json",
    }
  };

  return axios.request(config);
}
